import {
    Box,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Typography,
  } from "@mui/material";
  import React from "react";
  import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
  import PublicIcon from "@mui/icons-material/Public";
  import PublicOffIcon from "@mui/icons-material/PublicOff";
  import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';
import { CardImageComponent } from "../../Component/Component";
  const images = [
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://media.criticalhit.net/2018/05/BRVS.jpg",
      status: "Private",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://images8.alphacoders.com/877/877849.jpg",
      status: "Public",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://i.gadgets360cdn.com/large/fortnite_keyart_1505235339110.jpg",
      status: "Private",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://img.youtube.com/vi/KT7BwOCUXwY/maxresdefault.jpg",
      status: "Public",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://www.esrb.org/wp-content/uploads/2018/09/19BR_ESRB_ParentGuide_ESRB_ParentGuide_1920x1080_v2-1024x576.jpg",
      status: "Private",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://images6.alphacoders.com/934/934290.jpg",
      status: "Public",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://cdn.images.express.co.uk/img/dynamic/143/590x/Fortnite-907210.jpg",
      status: "Public",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://media.criticalhit.net/2018/05/BRVS.jpg",
      status: "Private",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://images8.alphacoders.com/877/877849.jpg",
      status: "Public",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://i.gadgets360cdn.com/large/fortnite_keyart_1505235339110.jpg",
      status: "Private",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://img.youtube.com/vi/KT7BwOCUXwY/maxresdefault.jpg",
      status: "Public",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://www.esrb.org/wp-content/uploads/2018/09/19BR_ESRB_ParentGuide_ESRB_ParentGuide_1920x1080_v2-1024x576.jpg",
      status: "Private",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://images6.alphacoders.com/934/934290.jpg",
      status: "Public",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://cdn.images.express.co.uk/img/dynamic/143/590x/Fortnite-907210.jpg",
      status: "Public",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://media.criticalhit.net/2018/05/BRVS.jpg",
      status: "Private",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://images8.alphacoders.com/877/877849.jpg",
      status: "Public",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://i.gadgets360cdn.com/large/fortnite_keyart_1505235339110.jpg",
      status: "Private",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://img.youtube.com/vi/KT7BwOCUXwY/maxresdefault.jpg",
      status: "Public",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://www.esrb.org/wp-content/uploads/2018/09/19BR_ESRB_ParentGuide_ESRB_ParentGuide_1920x1080_v2-1024x576.jpg",
      status: "Private",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://images6.alphacoders.com/934/934290.jpg",
      status: "Public",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://cdn.images.express.co.uk/img/dynamic/143/590x/Fortnite-907210.jpg",
      status: "Public",
      project: "Comming Soon",
    },
    {
      label: "Fortnite Battle Royale",
      imgPath:
        "https://media.criticalhit.net/2018/05/BRVS.jpg",
      status: "Private",
      project: "Comming Soon",
    },
  ];

const CompletedLaunchpad = () => {
  return (
    <Grid container className="upcomming-project-Grid" spacing={2}>
      {images.map((image, index) => {
        return (
          <Grid item xs={6} sm={6} md={3} lg={3} xl={3} key={index}>
            <Box sx={{ width: "100%" }}>
                <CardImageComponent sx={{ height: "300px", width: "100%" }}>
                  <img
                    className="cursor-pointer"
                    src={image?.imgPath}
                    alt={image.label}
                  />
                </CardImageComponent>
                <Box sx={{borderRadius: '100px 0px 0px 100px',background:'black',zIndex:1,position:'absolute',marginLeft:'10%',marginTop:'-17%',height:'7%',width:'150px',display:'flex'}}> 
                            <List sx={{fontSize:'10px',flexGrow:12,marginTop:'-3%'}}>
                              <ListItem >
                                <ListItemIcon>
                                <PublicIcon className="upcomming-project-text-status-public-btn" />
                                </ListItemIcon>
                                <ListItemText >
                                {image.status}
                              </ListItemText>
                              </ListItem>
                            </List>
                            </Box>
                <Grid container>
                  <Grid item lg={10}>
                    <Typography
                      variant="caption"
                      className="upcomming-project-text"
                    >
                      {image?.label}
                    </Typography>
                  </Grid>
                  <Grid item lg={2}>
                    <ListItemButton>
                      <ArrowCircleRightOutlinedIcon className="upcomming-project-btn" />
                    </ListItemButton>
                  </Grid>
                  <Divider />
                  <Grid item lg={6} sx={{paddingLeft:'5px',fontSize:'5px'}}>
                    <item >
                      <PublicOffIcon />
                      <PublicOffIcon />
                      <PublicOffIcon />
                      <PublicOffIcon />
                    </item>
                  </Grid>
                  <Grid
                    item
                    lg={12}
                    sx={{
                      paddingLeft: "5%",
                      paddingRight: "5%",
                      paddingBottom: "5%",
                    }}
                  >
                    <Table >
                      <TableBody>
                        <TableRow>
                          <TableCell
                            sx={{
                              borderBottom: "none",
                              color: "gray",
                              fontSize: "10px",
                              lineHeight: "2px",
                            }}
                          >
                            Rate
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                          colSpan={2}
                            sx={{
                              borderBottom: "none",
                              color: "#9543fe",
                              fontSize: "12px",
                              lineHeight: "2px",
                            }}
                          >
                            1 XETA = 0.01 BUSD
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              borderBottom: "none",
                              color: "gray",
                              fontSize: "10px",
                              lineHeight: "2px",
                            }}
                          >
                            IGO NETWORK
                          </TableCell>
                          <TableCell
                            sx={{
                              borderBottom: "none",
                              color: "gray",
                              fontSize: "10px",
                            }}
                          >
                            TOKEN NETWORK
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              borderBottom: "none",
                              color: "white",
                              lineHeight: "2px",
                            }}
                          >
                           <Box sx={{justifyContent:'center', fontSize:'10px'}}>
                            <CurrencyBitcoinIcon sx={{backgroundColor:'yellow',color:'black',borderRadius:'20px',padding:'2px',fontSize:'10px'}} />
                            <Typography variant="caption" sx={{marginTop:'-10%',fontSize:'10px'}}> BNB CHAIN</Typography>
                            </Box>
                          </TableCell>
                          <TableCell
                            sx={{
                              borderBottom: "none",
                              color: "white",
                              lineHeight: "2px",
                            }}
                          >
                           <Box sx={{justifyContent:'center', fontSize:'10px'}}>
                            <CurrencyBitcoinIcon sx={{backgroundColor:'yellow',color:'black',borderRadius:'20px',padding:'2px',fontSize:'10px'}} />
                            <Typography variant="caption" sx={{marginTop:'-10%',fontSize:'10px'}}> BNB CHAIN</Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              borderBottom: "none",
                              color: "gray",
                              fontSize: "12px",
                              lineHeight: "2px",
                            }}
                          >
                            TOTAL RAISE
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              borderBottom: "none",
                              color: "white",
                              fontSize: "12px",
                              lineHeight: "2px",
                            }}
                          >
                            $94,000
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            colSpan={2}
                            sx={{
                              maxWidth:'100%' ,
                              textAlign:'center' ,
                              borderBottom: "none",
                              color: "gray",
                              fontSize: "12px",
                              lineHeight: "2px",
                            }}
                          >
                            whitelist ends in
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                          colSpan={2}
                            sx={{
                              maxWidth:'100%' ,
                              textAlign:'center' ,
                              borderBottom: "none",
                              color: "white",
                              fontSize: "12px",
                              lineHeight: "2px",
                            }}
                          >
                            05d : 23h : 11m : 45s
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Grid>
                </Grid>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default CompletedLaunchpad;